import { onLoaded } from "@/utils"
import * as packedge from "../../shared/packedge.js"

// Global license status
let licenseStatus = {
    isValid: false,
    isChecking: false
}

// Prevent multiple initializations
let licenseInitialized = false

/**
 * Check if license is active
 */
const isLicenseActive = () => {
    const license = ajaxpress_vars?.license || {}
    return !!(license.key && license.status === 'active')
}

const License = () => {
    // Prevent re-initialization
    if (licenseInitialized) {
        return
    }

    let license = null

    onLoaded(() => {
        // Prevent re-initialization
        if (licenseInitialized) {
            return
        }

        // Mark as initialized
        licenseInitialized = true

        license = ajaxpress_vars.license || {}
        
        // Set initial license status
        licenseStatus.isValid = isLicenseActive()

        if (!license.key || license.status !== 'active') {
            return
        }

        checkLicenseValidity()
    })

    const checkLicenseValidity = async () => {
        let lastCheck = null
        const now = Date.now()
        const twelveHoursInMs = 12 * 60 * 60 * 1000

        // Try to get last check from localStorage with error handling
        try {
            lastCheck = localStorage.getItem('ajaxpress_license_last_check')
        } catch (error) {
            // localStorage not available
        }

        if (lastCheck && (now - parseInt(lastCheck)) < twelveHoursInMs) {
            return
        }

        if (!navigator.onLine) {
            return
        }

        licenseStatus.isChecking = true

        try {
            const result = await packedge.validate(license.key)

            if (result.networkError) {
                // Keep current status on network failure.
                return
            }

            if (result.success && result.valid) {
                try {
                    localStorage.setItem('ajaxpress_license_last_check', now.toString())
                } catch (error) {
                    // Failed to save timestamp
                }
                licenseStatus.isValid = true
            } else {
                licenseStatus.isValid = false
            }
        } catch (error) {
            // On unexpected error, keep current status
        } finally {
            licenseStatus.isChecking = false
        }
    }
}

export default License
